import React, { FC, useCallback } from 'react';
import { Range, getTrackBackground } from 'react-range';

import styles from './RangeInput.module.scss';

export const preventSwipeGesture = (event: TouchEvent): void => {
  if ((event.target as Element).classList.contains(styles.handle)) {
    event.preventDefault();
  }
};

export type RangeInputProps = {
  min: number;
  max: number;
  step?: number;
  values?: number[];
  onChange: (value: number[]) => void;
  onFinalChange: (value: number[]) => void;
  children?: React.ReactNode;
};

const RangeInput: FC<RangeInputProps> = ({
  step,
  min,
  max,
  values,
  onChange,
  onFinalChange,
}) => {
  const getPriceWithinLimits = useCallback((price: number) => {
    if (price > max) return max;
    if (price < min) return min;
    return price;
  }, [min, max]);

  const getLimitedValues = useCallback(
    () => values.map(((value) => getPriceWithinLimits(value))),
    [values, getPriceWithinLimits],
  );

  const trackBackground = getTrackBackground({
    values: getLimitedValues(),
    min,
    max,
    colors: ['#e6edef', '#a3aeb2', '#e6edef'],
  });
  return (
    <Range
      step={step}
      min={min}
      max={max}
      values={getLimitedValues()}
      onChange={onChange}
      onFinalChange={onFinalChange}
      renderTrack={({ props, children }) => (
        <div
          className={styles.track}
          ref={props.ref}
          style={{
            ...props.style,
            background: trackBackground,
          }}
        >
          {children}
        </div>
      )}
      renderThumb={({ props }) => (
        <div
          {...props}
          key={props.key}
          className={styles.handle}
        />
      )}
    />
  );
};

export default RangeInput;
